<template>
  <transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform scale-95 opacity-0"
    enter-to-class="transform scale-100 opacity-100"
    leave-active-class="transition duration-75 ease-in"
    leave-from-class="transform scale-100 opacity-100"
    leave-to-class="transform scale-95 opacity-0"
  >
    <div>
      <div
        class="confirm-window shadow-lg"
        :class="`bg-${color}`"
        v-bind="$attrs"
        v-if="showConfirmation"
      >
        <div class="flex flex-row items-center h-full">
          <div class="my-auto relative top-0 left-0">
            <svg
              width="148"
              height="148"
              viewBox="0 0 148 148"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M73.9999 14.8C64.2142 14.8 56.6773 23.4343 57.9995 33.1303L65.6001 88.8678C66.1729 93.0684 69.7605 96.2 73.9999 96.2C78.2393 96.2 81.8269 93.0684 82.3997 88.8679L90.0003 33.1303C91.3225 23.4343 83.7857 14.8 73.9999 14.8Z"
                fill="white"
              />
              <path
                d="M73.9999 133.2C82.1737 133.2 88.7999 126.574 88.7999 118.4C88.7999 110.226 82.1737 103.6 73.9999 103.6C65.8261 103.6 59.1999 110.226 59.1999 118.4C59.1999 126.574 65.8261 133.2 73.9999 133.2Z"
                fill="white"
              />
            </svg>
          </div>

          <div
            class="flex flex-col h-full justify-center relative top-0"
            style="right: 30px"
          >
            <div class="flex flex-row items-center justify-center mb-3">
              <span class="text-white text-lg font-bold text-center">
                データを
              </span>
              <TrashIcn
                fill-rule="evenodd"
                class="mr-1 white-icon"
                width="16px"
                height="18px"
              />
              <span class="text-white text-lg font-bold text-center">
                削除してよろしいですか？
              </span>
            </div>

            <hr class="border-dotted border-white" />
            <span class="text-white text-lg text-center mt-3">
              この操作は元に戻せません
            </span>

            <div class="mt-3">
              <button
                class="h-10 bg-white border-4 rounded-full mr-2"
                :class="`border-${color}`"
                style="width: 168px;"
                @click="confirmAction(true)"
              >
                <div class="flex flex-row items-center justify-center">
                  <TrashIcn
                    fill-rule="evenodd"
                    class="mr-1"
                    width="16px"
                    height="18px"
                    :class="`${color}-icon`"
                  />
                  <span class="text-lg font-bold" :class="`text-${color}`">
                    はい
                  </span>
                </div>
              </button>
              <button
                class="h-10 bg-white border-4 rounded-full"
                :class="`border-${color}`"
                style="width: 168px;"
                @click="confirmAction(false)"
              >
                <span class="text-lg font-bold" :class="`text-${color}`">
                  いいえ
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showConfirmation"
        class="overlay"
        @click="confirmAction(false)"
      ></div>
    </div>
  </transition>
</template>

<script>
import TrashIcn from '@/assets/icons/trash.svg?inline'
import { useConfirmation } from '@/services/useConfirmation'

export default {
  name: 'AppConfirm',

  components: { TrashIcn },

  props: {
    color: String,
  },

  setup() {
    return { ...useConfirmation() }
  },
}
</script>
<style lang="scss" scoped>
.confirm-window {
  width: 592px;
  height: 160px;
  position: fixed;
  top: 50%;
  right: 0px;
  transform: translate(0%, -50%);
  z-index: 999;
  border: 2px solid #ffffff;
  border-radius: 900px 0px 0px 900px;
}

.overlay {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  text-indent: -99999px;
  background: rgba(0, 0, 0, 0.3);
}
</style>
